import { AgentChatProvider } from '@/contexts/AgentChatContext';
import agentCollapse from '../../assets/images/agentCollapse.png';
import sidebarExpand from '../../assets/svgs/icons/sidebar-expand.svg';
import { DynamicPageAgentChat } from '../AgentChat/DynamicPageAgentChat';

interface DynamicPageSidebarProps {
  collapsed: boolean;
  onCollapseChange: (collapsed: boolean) => void;
}

export const DynamicPageSidebar = ({
  collapsed,
  onCollapseChange,
}: DynamicPageSidebarProps) => {
  return (
    <AgentChatProvider agentName="dynamicPageAgent">
      <div
        className={
          'flex h-full flex-col border-l border-gray-200 bg-white transition-all duration-300 ease-in-out'
        }
      >
        {!collapsed && (
          <img
            src={agentCollapse}
            alt="collapse"
            className="absolute top-1/2 -left-3.5 w-7 -translate-y-1/2 cursor-pointer"
            onClick={() => onCollapseChange(true)}
          />
        )}
        {!collapsed && (
          <DynamicPageAgentChat
            agentName="dynamicPageAgent"
            placeholder="Ask me anything about this dynamic page..."
          />
        )}
        {collapsed && (
          <div
            className="flex h-full cursor-pointer flex-col items-center justify-center gap-2"
            onClick={() => onCollapseChange(false)}
            style={{
              background: 'linear-gradient(180deg, #F7F5FF 0%, #E5EEFF 100%)',
            }}
          >
            <div className="font-manrope pointer-events-none rotate-180 text-sm font-medium whitespace-nowrap text-[#344051] [writing-mode:vertical-lr]">
              AI Assistant
            </div>
            <img src={sidebarExpand} className="size-5" />
          </div>
        )}
      </div>
    </AgentChatProvider>
  );
};
